module.exports = __webpack_public_path__ + "media/images/ticket_04-ecc39f55d2f047e5109be43464e270c8.png";